<template>
  <div class="winners-2021-place-chip">
    <slot />
  </div>
</template>

<script>
export default {
  name: "Winners2021PlaceChip"
};
</script>

<style lang="scss">
.winners-2021-place-chip {
  background-image: linear-gradient(to bottom, #f4ad3b, #e74e33);
  border-radius: 30px;

  display: flex;
  align-items: center;
  justify-content: center;

  font-size: 16px;
  font-weight: 800;
  text-transform: uppercase;
}
</style>
